import Vue from "vue";
// Element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import App from "./App.vue";
import router from "./router/index.js";
import echarts from 'echarts'
//Vuex 状态存储
import Vuex from 'vuex'
import store from "./vuex/store";
//api域名配置
import ENVConfig from "./../public/api.json";
//css 初始化
import '../src/assets/css/normalize.css';
//公共css
import '../src/assets/css/common.css';
import "../node_modules/echarts/map/js/china.js"

// import '../src/assets/js/LodopFuncs.js'

//拖动排序组件
// import VueDND from 'awe-dnd'

//引入自己再次封装的axios  http请求方式
import http from './../src/assets/js/axios.js';
import commonFn from './../src/assets/js/common.js';
import globalComponent from './../public/globalComponents.js'

window.$axios = http;
window.$commonFn = commonFn;


// Vue.use(VueDND)
Vue.use(ElementUI);
Vue.use(Vuex);
Vue.use(globalComponent)
Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts



let promise = new Promise((resolve, reject) => {
    // console.log(ENVConfig.ENVconfig)

    if (ENVConfig.ENVconfig.toLowerCase() == 'dev') {
        resolve([ENVConfig.dev.http_api])
    }
    if (ENVConfig.ENVconfig.toLowerCase() == 'build') {
        resolve([ENVConfig.build.http_api])
    }
})
promise.then(res => {
    let appVue = new Vue({
        router,
        store,
        render: h => h(App),
        beforeCreate: function() {
            this.$store.state.apiUrl = res[0];
        }
    }).$mount("#app");
    window.$bus = appVue;
})